import { RawRepetitionPerformance } from "../types/api/repetition";
import { RepetitionPerformance } from "../types/ui/Repetition";

export function toRepetitionPerformance(
  raw: RawRepetitionPerformance,
  index: number
): RepetitionPerformance {
  return {
    id:               index + 1,
    drillName:        raw.drill,
    repetitionNumber: raw.repetition,
    speed:            raw.speed,
    accuracyScore:    raw.accuracy_score,
    shotScore:        raw.shot_score,
    hitFactor:        raw.hit_factor,
    hits:             raw.n_hits,
    hitRatio:         raw.hits_ratio,
  };
}

export function toRepetitionPerformances(
  raws: RawRepetitionPerformance[]
): RepetitionPerformance[] {
  return raws.map((r, i) => toRepetitionPerformance(r, i));
}